import type { Nullable } from '../types';

export const localStorageAccessor = <T>(
  key: string,
  value?: any
): Nullable<T> => {
  try {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
      return;
    }
    const unparsedData = localStorage.getItem(key);
    return JSON.parse(unparsedData);
  } catch (e) {
    console.log('Error during access to localStorage', e);
  }
  return null;
};
